import { ButtonGroup, Fieldset, Form, Layout } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { journeyDataActions, journeyDataSelectors } from '../../services/redux/features/journeyData.slice';
import { CustomerTypeEnum } from '../../types/customerTypeSelection';
import { ProductFamilyEnum } from '../../types/productFamilySelection';

export const ProductFamilySelectionForm: FunctionComponent = () => {
  const dispatch = useDispatch();

  const productFamily = useSelector(journeyDataSelectors.productFamily);
  const customerType = useSelector(journeyDataSelectors.customerType);

  return (
    <Form>
      <Fieldset.Row>
        <Layout className="u-m-none">
          <Layout.Item default="1/1">
            <ButtonGroup buttonGroupName="formSelector" buttonGroupType="radio">
              {(!customerType || customerType === CustomerTypeEnum.consumer) && (
                <>
                  <ButtonGroup.Item
                    index="productFamiliSelection_1"
                    readOnly
                    disabled={!customerType}
                    buttonGroupItemIcon="hand-key"
                    checked={productFamily === ProductFamilyEnum.privateLease}
                    testId="button_product_privateLease"
                    onClick={() => {
                      dispatch(journeyDataActions.setProductFamily(ProductFamilyEnum.privateLease));
                    }}
                  >
                    {t('productFamilySelectionPage:productFamily.privateLease')}
                  </ButtonGroup.Item>

                  <ButtonGroup.Item
                    index="productFamiliSelection_2"
                    readOnly
                    disabled={!customerType}
                    buttonGroupItemIcon="cars-right-left"
                    checked={productFamily === ProductFamilyEnum.servicePlan}
                    testId="button_product_servicePlan"
                    onClick={() => {
                      dispatch(journeyDataActions.setProductFamily(ProductFamilyEnum.servicePlan));
                    }}
                  >
                    {t('productFamilySelectionPage:productFamily.servicePlan')}
                  </ButtonGroup.Item>
                </>
              )}

              {(!customerType || customerType === CustomerTypeEnum.business) && (
                <>
                  <ButtonGroup.Item
                    index="productFamiliSelection_3"
                    readOnly
                    disabled={!customerType}
                    buttonGroupItemIcon="semantic-briefcase"
                    checked={productFamily === ProductFamilyEnum.operatingLease}
                    testId="button_product_operatingLease"
                    onClick={() => {
                      dispatch(journeyDataActions.setProductFamily(ProductFamilyEnum.operatingLease));
                    }}
                  >
                    {t('productFamilySelectionPage:productFamily.operatingLease')}
                  </ButtonGroup.Item>

                  <ButtonGroup.Item
                    index="productFamiliSelection_4"
                    readOnly
                    disabled={!customerType}
                    buttonGroupItemIcon="cars-right-left"
                    checked={productFamily === ProductFamilyEnum.servicePlan}
                    testId="button_product_servicePlan"
                    onClick={() => {
                      dispatch(journeyDataActions.setProductFamily(ProductFamilyEnum.servicePlan));
                    }}
                  >
                    {t('productFamilySelectionPage:productFamily.servicePlan')}
                  </ButtonGroup.Item>
                </>
              )}

              {/*
            // This product type is disabled for now
            <ButtonGroup.Item
            index="1"
            readOnly
            buttonGroupItemIcon="car-three-stars"
            checked={productFamily === ProductFamilyEnum.financialProduct}
            testId="button_product_financialProduct"
            onClick={() => {
              dispatch(productFamilySelectionPageActions.setProductFamily(ProductFamilyEnum.financialProduct));
            }}
          >
            {t('productFamilySelectionPage:productFamily.financialProduct')}
          </ButtonGroup.Item> */}
            </ButtonGroup>
          </Layout.Item>
        </Layout>
      </Fieldset.Row>
    </Form>
  );
};
